import React from "react";
import { Modal } from "@pd/pd-ui-kit";

import Preloader from "~/components/Preloader";
import { useHistoryContract } from "~/entity/Contract";
import { useGetTemplateList } from "~/entity/Template";
import { HistoryItem } from "~/pages/ListOfDocuments/Modals/Components/HistoryItem";
import { TITLES } from "~/pages/ListOfDocuments/Modals/options";

import style from "~/pages/ListOfDocuments/Modals/style.less";

interface HistoryContractIProps {
  open: boolean;
  onClose: () => void;
  dealerObj: any;
}

const HistoryContract = ({ open, onClose, dealerObj }: HistoryContractIProps) => {
  const { contractNumber, contractId, contractDate, name, code, inn } =
    dealerObj;

  const { data, isLoading } = useHistoryContract(contractId);
  const { data: dataTemplate } = useGetTemplateList();

  const getNameTemplate = (id: number) => {
    const template = dataTemplate.find((item) => item.id === id);
    return template.name;
  };
  return (
    <Modal
      open={open}
      title={TITLES.doc.history}
      onCancel={onClose}
      centered
      destroyOnHidden
      size="large"
      cancelButton={{ children: "Закрыть" }}
    >
      <div className={style.wrapperHistoryContent}>
        <div className={style.historyList}>
          <ul>
            <li>Договор № {contractNumber}</li>
            <li>Дата договора: {contractDate}</li>
            <li>Дилер: {name}</li>
            <li>Филиал: {code}</li>
            <li>ИНН: {inn}</li>
          </ul>
        </div>
        <div className={style.horizontalLine} />
        <div className={`${style.historyList} ${style.bottomBorder}`}>
          <ul>
            <li className={style.titleHistoryList}>История изменений</li>
            {!isLoading && data?.length ? (
              data.map((item) => {
                return (
                  <li key={item.id}>
                    <HistoryItem
                      oldValue={item?.oldValue ?? ""}
                      newValue={item.newValue}
                      createdAt={item.createdAt}
                      fieldName={item.fieldName}
                      getNameTemplate={getNameTemplate}
                    />
                  </li>
                );
              })
            ) : (
              <Preloader />
            )}
          </ul>
        </div>
      </div>
    </Modal>
  );
};

export default HistoryContract;
